import axios, { AxiosRequestConfig } from 'axios';

import UserCred from '../models/UserCred';
import U from './Utils';
import CSharpUtils from './CSharpUtils';

export const loginToAutodataDotNet = (userCred: UserCred) => {
  const config = {
    method: 'post',
    baseURL: `${`${U.URL_ADDRESS}${U.DOTNET_DEV_SERVICE}`}/auth/login`,
    maxContentLength: 1000000,
    timeout: 10000,
    headers: {
      'content-type': 'application/json',
      Accept: 'application/json;charset=utf-8',
    },
    data: {
      username: userCred.username,
      password: userCred.password,
    },
    responseType: 'json',
    responseEncoding: 'utf8',
    withCredentials: false,
    secure: false,
    changeOrigin: true,
    mode: 'no-cors',
  } as AxiosRequestConfig;
  return axios.request(config);
};

export const autoLoginToAutodataDotNetAPI = (token: string, btsg: string) => {
  const tabId = btsg;
  const config = {
    method: 'post',
    baseURL: `${`${U.URL_ADDRESS}${U.DOTNET_DEV_SERVICE}`}/auth/refresh`,
    maxContentLength: 1000000,
    timeout: 20000,
    headers: {
      'content-type': 'application/json',
      Accept: 'application/json;charset=utf-8',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`,
    },
    data: {
      token,
      tabId,
    },
    responseType: 'json',
    responseEncoding: 'utf8',
    withCredentials: false,
    secure: false,
    changeOrigin: true,
    mode: 'no-cors',
  } as AxiosRequestConfig;
  return axios.request(config);
};

// StepArticle API calls
export const searchStepArticles = (searchRequest: any) => {
  const proxyUrl = `${U.URL_ADDRESS}${U.DOTNET_DEV_SERVICE}/api/step-articles/search`;
  
  // Debug logging
  console.log('StepArticle API Debug:');
  console.log('URL_ADDRESS:', U.URL_ADDRESS);
  console.log('DOTNET_DEV_SERVICE:', U.DOTNET_DEV_SERVICE);
  console.log('Proxy URL:', proxyUrl);
  console.log('Search Request:', searchRequest);
  console.log('Token:', CSharpUtils.Get_Token);
  
  const config = {
    method: 'post',
    baseURL: proxyUrl,
    maxContentLength: 1000000,
    timeout: 20000,
    headers: {
      'content-type': 'application/json',
      Accept: 'application/json;charset=utf-8',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`,
    },
    data: searchRequest,
    responseType: 'json',
    responseEncoding: 'utf8',
    withCredentials: false,
    secure: false,
    changeOrigin: true,
    mode: 'no-cors',
  } as AxiosRequestConfig;
  return axios.request(config);
};

export const previewStepArticleUpload = (formData: FormData) => {
  const config = {
    method: 'post',
    baseURL: `${U.URL_ADDRESS}${U.DOTNET_DEV_SERVICE}/api/step-articles/preview`,
    maxContentLength: 10000000,
    timeout: 30000,
    headers: {
      'content-type': 'multipart/form-data',
      Accept: 'application/json;charset=utf-8',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`,
    },
    data: formData,
    responseType: 'json',
    responseEncoding: 'utf8',
    withCredentials: false,
    secure: false,
    changeOrigin: true,
    mode: 'no-cors',
  } as AxiosRequestConfig;
  return axios.request(config);
};

export const processStepArticleUpload = (formData: FormData) => {
  const config = {
    method: 'post',
    baseURL: `${U.URL_ADDRESS}${U.DOTNET_DEV_SERVICE}/api/step-articles/process`,
    maxContentLength: 10000000,
    timeout: 30000,
    headers: {
      'content-type': 'multipart/form-data',
      Accept: 'application/json;charset=utf-8',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`,
    },
    data: formData,
    responseType: 'json',
    responseEncoding: 'utf8',
    withCredentials: false,
    secure: false,
    changeOrigin: true,
    mode: 'no-cors',
  } as AxiosRequestConfig;
  return axios.request(config);
};

